"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

export const documentSearchToolRegistry = {
  documentSearch: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./document-search").then(({ DocumentSearchToolView }) => ({
        default: DocumentSearchToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
